import {Component, OnInit} from '@angular/core';
import {SpecialCompbaser} from "../compbaser";
import {calcLicenses, isNullOrUndefOrEmpty} from "../../common";
import {faRightFromBracket} from "@fortawesome/free-solid-svg-icons";

@Component({
    selector: 'app-estimates',
    templateUrl: './estimates.component.html',
    styleUrls: ['./estimates.component.scss']
})
export class EstimatesComponent extends SpecialCompbaser implements OnInit {

    protected readonly faRightFromBracket = faRightFromBracket;

    modal = 1;
    licence: any = 0;
    licences: any = 0;
    totalScreens = 0;
    userStorage = 1000;
    exceed = false;
    MAX_BANDWIDTH_MB = 1000;
    showToggle = true;
    toggleIcon = true;

    public stringJSPipeArgs = {toCurrency: ['us']};

    constructor() {
        super();
    }

    ngOnInit(): void {

    }

    toggleVideoPane(){

    }

    calcBandwidth(i_activeConnections) {
        this.exceed = ((i_activeConnections * this.userStorage) > this.MAX_BANDWIDTH_MB);
    }

    onPrice(e) {
        let v = parseInt(e.target.value);
        if (isNullOrUndefOrEmpty(v)) return;
        this.totalScreens = v;
        const p = calcLicenses(v, null);
        this.licence = p.license;
        this.licences = p.licenses;
        this.calcBandwidth(v);
    }

    onMaxCloudBandwidth(e) {
        this.MAX_BANDWIDTH_MB = parseInt(e.target.value);
        this.onPrice({target: {value: this.totalScreens}});
    }

    onUserStorage(e) {
        this.userStorage = parseInt(e.target.value);
        this.onPrice({target: {value: this.totalScreens}});
    }

    clearFilterSelection() {
        this.modal = 1;
    }
}
